<template>
  <div>
    <a-upload
      ref="imageUploader"
      class="avatar-uploader"
      name="file"
      :headers="headers"
      :action="uploadUrl"
      :multiple="true"
      :show-upload-list="false"
      :before-upload="beforeUpload"
      @change="handleChange">
    </a-upload>
    <a-row>
      <div>
        <quill-editor
          v-model="content"
          ref="myQuillEditor"
          :options="editorOption"
        >
        </quill-editor>
      </div>
    </a-row>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

/**
 * 文件上传之前的回调函数
 */
function beforeAvatarUpload(file) {
  const flag = this.compareImage(file);
  if (!flag) {
    this.$confirm({
      title: '上传文件必须为图片格式？',
      content: '',
      onOk: async () => {
      },
    });
  }
  return flag;
}

/**
 *  判断上传文件是否为图片
 * @param file
 * SUN
 */
function compareImage(file) {
  let flag = true;
  const fileName = this.getLast3Str(file);
  if (fileName !== 'svg' && fileName !== 'png' && fileName !== 'jpg') {
    flag = false;
  }
  return flag;
}

/**
 * 上传成功
 */
function handleImageSuccess(res, file) {
  if (res) {
    this.imageUrl = URL.createObjectURL(file.raw);
    const img = res;
    this.$set(this.form.data, 'img', img);
  }
}

/**
 * 获取上传文件的后缀名字符串 （后缀长度均为3）
 * @param file
 * @returns {string} SUN
 */
function getLast3Str(file) {
  const fileName = file.name;
  const index = fileName.lastIndexOf('.') + 1;
  return fileName.substring(index);
}

// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  // ['blockquote'],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  // [{ direction: 'rtl' }], // text direction
  // [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ align: [] }],
  ['image'],
  ['clean'], // remove formatting button
];
export default {
  name: 'HtmlEditor',
  props: {
    value: String,
  },
  watch: {
    value(val) {
      this.content = val;
    },
    content(val) {
      this.$emit('input', val);
    },
  },
  data() {
    const that = this;
    return {
      headers: {
        token: localStorage.getItem('token'),
      },
      uploadUrl: `${process.env.VUE_APP_BASE_URL}/upload`,
      content: this.value,
      imageUrl: '',
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示,
      editorOption: {
        placeholder: '',
        theme: 'snow', // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image(value) {
                if (value) {
                  that.$refs.imageUploader.$el.childNodes[0].childNodes[0].click();
                } else {
                  this.quill.format('image', false);
                }
              },
            },
          },
        },
      },
    };
  },
  methods: {
    compareImage,
    beforeAvatarUpload,
    handleImageSuccess,
    getLast3Str,
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    handleChange(info) {
      this.quillUpdateImg = true;
      if (info.file.status === 'done') {
        const { quill } = this.$refs.myQuillEditor;
        // 如果上传成功
        if (info.file.response) {
          // 获取光标所在位置
          const length = quill.getSelection().index;
          // 插入图片  res.info为服务器返回的图片地址
          quill.insertEmbed(length, 'image', `${info.file.response}`);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          this.$message.error('图片插入失败');
        }
        // loading动画消失
      }
      this.quillUpdateImg = false;
    },
  },
  created() {
  },
  components: {
    quillEditor,
  },
};
</script>

<style>

.ql-editor {
  min-height: 500px;
  max-height: 800px;
}

.ql-toolbar.ql-snow {
  border: 1px solid #DCDFE6;
}

.ql-container.ql-snow {
  border: 1px solid #DCDFE6;
}

</style>
